import { Component, Input, OnInit } from '@angular/core';
import { InventoryItemGroup } from 'src/app/models/results/inventory-item-group';
import { InventoryItemViewModel } from 'src/app/models/results/inventory-item-view-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-device-result',
  templateUrl: './device-result.component.html',
  styleUrls: ['./device-result.component.scss']
})
export class DeviceResultComponent implements OnInit {
  @Input() group: InventoryItemGroup = new InventoryItemGroup(new InventoryItemViewModel(), []);
  showSecondaryDevices: boolean = false;
  viewAdditionalOptionsBeginning: string = "";
  hideAdditionalOptionsBeginning: string = "";
  additionalOptionsEnd: string = "";
  i18nViewAdditionalOptions: string = "";
  i18nHideAdditionalOptions: string = "";
  viewAdditionalOptionsButtonText: string = "";
  hideAdditionalOptionsButtonText: string = "";

  constructor(private confSvc: ConfigService, private utilityService: UtilityService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.viewAdditionalOptionsBeginning = this.confSvc.getString("viewAdditionalOptionsBeginning");
    this.hideAdditionalOptionsBeginning = this.confSvc.getString("hideAdditionalOptionsBeginning");
    this.additionalOptionsEnd = this.confSvc.getString("additionalOptionsEnd");
    this.i18nViewAdditionalOptions = this.confSvc.getString("i18nViewAdditionalOptions");
    this.i18nHideAdditionalOptions = this.confSvc.getString("i18nHideAdditionalOptions");

    this.setButtonText();
  }

  setButtonText(): void {
    if ( this.utilityService.getLocaleInfo().isEnglish) {
      // remove the 's' if only 1
      let endText = (this.group.secondaryItems.length === 1) ? this.additionalOptionsEnd.slice(0, -1) : this.additionalOptionsEnd;

      this.viewAdditionalOptionsButtonText = `${this.viewAdditionalOptionsBeginning}${this.group.secondaryItems.length}${endText}`;
      this.hideAdditionalOptionsButtonText = `${this.hideAdditionalOptionsBeginning}${this.group.secondaryItems.length}${endText}`;
    } else {
      this.viewAdditionalOptionsButtonText = this.i18nViewAdditionalOptions;
      this.hideAdditionalOptionsButtonText = this.i18nHideAdditionalOptions;
    }
  }
}
